import { useMemo } from 'react'
import {
  getVariantsMinimumOrderQuantity,
  getVariantsQuantityUnit,
} from '@public/Showroom/Products/Detail/utils'
import { type ManagedCustomFields } from 'types/graphql-generated'

export const useProductVariantQuantity = ({
  managedCustomFields,
}: {
  managedCustomFields: Pick<
    ManagedCustomFields,
    | 'enableCounter'
    | 'quantityUnitPlural'
    | 'quantityUnitSingular'
    | 'minimumQuantity'
  >
}) => {
  const { isCounterEnabled, minimumOrderQuantity, quantityUnit } = useMemo(
    () => ({
      isCounterEnabled: managedCustomFields?.enableCounter,
      minimumOrderQuantity: getVariantsMinimumOrderQuantity({
        managedCustomFields,
      }),
      quantityUnit: getVariantsQuantityUnit({
        managedCustomFields,
      }),
    }),
    [managedCustomFields]
  )

  return {
    isCounterEnabled,
    minimumOrderQuantity,
    quantityUnit,
  }
}
